import DE_PRICING_PAGE_CONSTANTS from './de'
import EN_PRICING_PAGE_CONSTANTS from './en'
import FR_PRICING_PAGE_CONSTANTS from './fr'
import HU_PRICING_PAGE_CONSTANTS from './hu'
import { T_PRICING_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const PRICING_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_PRICING_PAGE_CONSTANTS> =
  {
    hu: HU_PRICING_PAGE_CONSTANTS,
    en: EN_PRICING_PAGE_CONSTANTS,
    fr: FR_PRICING_PAGE_CONSTANTS,
    de: DE_PRICING_PAGE_CONSTANTS
  }

export default PRICING_PAGE_CONSTANTS

export const PRICING_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_PRICING_PAGE_CONSTANTS>()
